import React, { Component } from 'react';
import RichText from 'legacy/src/utility/RichText';

import { combined } from '../shared/status';

class Player extends Component {
  render() {
    const {
      item: { content },
      childPlayer,
      context: { hDepth = 0 },
    } = this.props;
    return (
      <div>
        {content.items.map((child, index) => (
          <div key={index}>
            {child.title ? <h3>{child.title}</h3> : null}
            {child.description ? (
              <RichText content={child.description} />
            ) : null}
            {childPlayer(index, child, {
              hDepth: hDepth + (child.title ? 1 : 0),
            })}
          </div>
        ))}
      </div>
    );
  }
}

Player.displayName = 'List';

export default { Player, status: combined };
